// The user dashboard this admin panel hands sessions to (login as user, support
// sign-in). Picked from where the panel itself runs, so stage.admin.ginox.io opens
// testapp.ginox.io and only admin.ginox.io opens the live app — a stage build can
// never sign an operator into production. Localhost lands on stage too.
//
// ponytail: hostname rule rather than a REACT_APP_* var, so no GitHub secret has to
// change per environment. Move it to an env var if a third dashboard host appears.
export const DASHBOARD_HOST =
  typeof window !== "undefined" && window.location.hostname === "admin.ginox.io"
    ? "app.ginox.io"
    : "testapp.ginox.io";

export const DASHBOARD_URL = `https://${DASHBOARD_HOST}`;
